var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EDECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12L24.1364 16.7027V18.5947H27.2273V26.4324H28V28H11V26.4324H11.7727V18.5947H14.8636V16.7027L19.5 12ZM24.1364 26.4324H25.6818V20.1622H24.1364V26.4324ZM14.8636 20.1622H13.3182V26.4324H14.8636V20.1622ZM16.4091 17.3516V26.4324H18.7273V20.946H20.2727V26.4324H22.5909V17.3516L19.5 14.2165L16.4091 17.3516Z",
    fill: "#4A3AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/SchoolIcon.0ea34290a745c6d9b484e953cf654e32.svg";
export { ForwardRef as ReactComponent };